import React, { useState } from 'react';
import { ChevronDown, Linkedin, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from './Header';

export default function LeadershipPage() {
  const [expandedLeader, setExpandedLeader] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleDropdown = (menu) => {
    setDropdownOpen(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  const leaders = [
    {
      id: 'anand',
      name: 'Anand Rathi',
      title: 'Founder & Group Chairman',
          image: '/Frame 18.png',
      social: ['linkedin'],
      shortBio: 'Mr Anand Rathi is the founder of the Anand Rathi Group. The Gold Medalist Chartered Accountant of 1965 is a leading financial and investment expert in India. Before laying the foundation of the Anand Rathi Group, Mr Rathi had an illustrious career at Mukesh Ambani promoted Reliance Group.',
      fullBio: 'Mr Rathi was the president of BSE (Bombay Stock Exchange) during 1990-2001. He spearheaded the task of setting up and expansion of BSE Online Trading System (BOLT). During his tenure of President and member of group Board.'
    },
    {
      id: 'pradeep',
      name: 'Pradeep Gupta',
      title: 'Co-Founder & Vice Chairman',
        image: '/Frame 18-1.png',
      social: ['linkedin', 'twitter'],
      shortBio: 'Mr Pradeep Gupta, is the co-founder of the group. Starting with a family-owned textile business, Mr Gupta stepped into the financial world.',
      fullBio: 'He was instrumental in the faster growth and success of the Institutional Broking and Investment Services arms of the group and remains the driving force behind the strong network of franchisees and branches across the country. He has over 3 decades of experience in financial services. Mr Gupta is also an active member of Rotary Club of Mumbai. Membership of Jaipur Stock Exchange and later of'
    },
    // {
    //   id: 'priti',
    //   name: 'Priti Rathi Gupta',
    //   title: 'Board Member Anand Rathi Share and Stock Brokers Limited',
    //   image: '/pr.png',
    //   social: ['linkedin', 'twitter'],
    //   shortBio: 'Mrs Priti Rathi Gupta laid the ground for the success of the Commodity and Currency Trading and Forex Advisory Business at Anand Rathi. Mrs Gupta did not limit herself to the financial sector and set up ishta Films to satiate her entrepreneurial and creative urges.',
    //   fullBio: 'She also leveraged digital financial services to give birth to a path breaking venture LXME. The platform helps women achieve financial literacy and investment expertise and produced 2 successful films'
    // },
    // {
    //   id: 'krishnav',
    //   name: 'Krishnav Gupta',
    //   title: 'Associate Director',
    //   image: '/Rectangle-4-3.png',
    //   social: ['linkedin'],
    //   shortBio: 'Krishnav is an engineering graduate from Imperial College London and has spent the last 2 years working at Ripple a leading crypto company in London, where he was responsible for setting up and launching new decentralized finance business verticals enabled by blockchain technology and working alongside Ripple\'s senior management team to chart strategic decisions.',
    //   fullBio: 'He is now closely associated with Investment Banking and Institutional Broking business.'
    // }
  ];


  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-300">
        <div className="pr-4 sm:pr-6 lg:pr-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <Link to="/">
                <img src="/logo.jpg" alt="Anand Rathi Logo" className="h-16 sm:h-20" />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-4 lg:space-x-8 text-gray-800 font-semibold text-sm lg:text-base">
              <div className="relative">
                <button
                  onClick={() => toggleDropdown('group')}
                  className="flex items-center hover:text-yellow-700 transition"
                >
                  GROUP <ChevronDown className="ml-1 h-4 w-4" />
                </button>
                {dropdownOpen.group && (
                  <div className="absolute top-full left-0 mt-1 w-48 bg-white shadow-lg border rounded-md z-50">
                    <Link to="/about" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">About</Link>
                    <Link to="/leadership" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Leadership</Link>
                    {/* <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Our Journey</a> */}
                  </div>
                )}
              </div>
              {/* <button className="flex items-center hover:text-yellow-700 transition">
                                  BUSINESSES
                              </button>
                              <button className="hover:text-yellow-700 transition">MEDIA</button>
                              <button className="flex items-center hover:text-yellow-700 transition">
                                  CAREER
                              </button> */}
              <Link to="/contact" className="hover:text-yellow-700 transition">CONTACT US</Link>
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t">
              <div className="space-y-2">
                <div>
                  <button
                    onClick={() => toggleDropdown('groupMobile')}
                    className="flex items-center justify-between w-full px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    GROUP <ChevronDown className="h-4 w-4" />
                  </button>
                  {dropdownOpen.groupMobile && (
                    <div className="pl-4 space-y-1">
                      <Link to="/about" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">About</Link>
                      <Link to="/leadership" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Leadership</Link>
                      {/*<a href="#" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Our Journey</a>*/}
                    </div>
                  )}
                </div>
                {/*<button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">BUSINESSES</button>
                <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">MEDIA</button>
                <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CAREER</button>*/}
                <Link to="/contact" className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CONTACT US</Link>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
        <img src="/leadership-banner.png" alt="Leadership Banner" className="w-full h-full object-cover" />
      </div>

      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="text-sm text-gray-600">
          Home » Group » Leadership
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          {/* Sidebar */}
          <div className="lg:w-64 flex-shrink-0">
            <div className="space-y-2 bg-white lg:bg-transparent p-4 lg:p-0 rounded lg:rounded-none shadow lg:shadow-none">
              <h3 className="text-base sm:text-lg font-semibold mb-4">About Us</h3>
              <Link to="/about" className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 block text-sm sm:text-base">
                About Us
              </Link>
              <button className="w-full text-left px-4 py-2 bg-yellow-600 text-white text-sm sm:text-base">
                Leadership
              </button>
              {/*<button className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 text-sm sm:text-base">
                Our Journey
              </button>*/}
            </div>
          </div>

          {/* Leadership Content */}
          <div className="flex-1">
            <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8 border-b-2 border-gray-300 pb-4">
              Leadership Team At Anand Rathi
            </h1>

            <div className="space-y-6 sm:space-y-8">
              {leaders.map((leader, index) => (
                <div
                  key={leader.id}
                  className={`bg-gray-50 p-4 sm:p-6 flex flex-col lg:flex-row gap-4 sm:gap-6 ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}
                >
                  <div className="w-full sm:w-80 lg:w-64 flex-shrink-0 mx-auto lg:mx-0">
                    <img
                      src={leader.image}
                      alt={leader.name}
                      className="w-full h-48 sm:h-56 lg:h-64 object-contain rounded bg-gray-100"
                    />
                    {/*<div className="flex gap-2 mt-3 justify-center lg:justify-start">
                      {leader.social.includes('linkedin') && (
                        <a href="#" className="w-8 h-8 flex items-center justify-center">
                          <img src="/Vector-1.png" alt="LinkedIn" className="w-6 h-6" />
                        </a>
                      )}
                      {leader.social.includes('twitter') && (
                        <a href="#" className="w-8 h-8 flex items-center justify-center">
                          <img src="/Vector-2.png" alt="Twitter" className="w-6 h-6" />
                        </a>
                      )}
                    </div>*/}
                  </div>

                  <div className="flex-1 text-center lg:text-left">
                    <h2 className="text-xl sm:text-2xl font-bold text-yellow-600 mb-1">
                      {leader.name}
                    </h2>
                    <h3 className="text-base sm:text-lg font-semibold mb-4">
                      {leader.title}
                    </h3>
                    <p className="text-gray-700 mb-4 text-sm sm:text-base leading-relaxed">
                      {leader.shortBio}
                    </p>
                    {expandedLeader === leader.id && (
                      <p className="text-gray-700 mb-4 text-sm sm:text-base leading-relaxed">
                        {leader.fullBio}
                      </p>
                    )}
                    <button
                      onClick={() => setExpandedLeader(expandedLeader === leader.id ? null : leader.id)}
                      className="text-yellow-600 hover:text-yellow-700 font-semibold flex items-center gap-2 mx-auto lg:mx-0 text-sm sm:text-base"
                    >
                      Read More
                      <ChevronDown className={`w-4 h-4 transform transition-transform ${expandedLeader === leader.id ? 'rotate-180' : ''}`} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
            <footer className="bg-gradient-to-br from-[#3a4a22] to-[#5a6a3a] text-white">
              <div className="container mx-auto px-4 py-8">
                <div className="grid md:grid-cols-4 gap-8 mb-6">
                  <div className="flex">
                    <div className="w-1 bg-white mr-4"></div>
                    <div>
                      <h4 className="text-white font-bold mb-4 font-sans">REGISTERED OFFICE:</h4>
                      <p className="text-sm text-[#D4C4A8] leading-relaxed font-sans">
                        1003 to 1012, 10th Floor, <br />
                          Dalal Street Commercial Cooperative Society Ltd.<br />
                          Block 53E, Zone-5, Road-5E, Gift City,<br />
                          District - Gandhinagar, Gujarat - 382355
                      </p>
                      <p className="text-sm text-[#D4C4A8] leading-relaxed font-sans mt-2">
                        Contact No. 022 6281 7003
                      </p>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-1 bg-white mr-4"></div>
                    <div>
                      <h4 className="text-white font-bold mb-4 font-sans">QUICK LINKS</h4>
                      <div className="space-y-2 text-sm font-sans">
                        <Link to="/kyc-vernacular-language" className="block text-[#D4C4A8] hover:text-white transition">KYC Vernacular Language</Link>
                        <a href="https://smartodr.in/login" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">ODR Portal</a>
                        <a href="https://eservices.nsdl.com" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">NSDL E-Voting</a>
                        <a href="https://evoting.cdslindia.com/Evoting/EvotingLogin" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">CDSL E-Voting</a>
                      </div>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-1 bg-white mr-4"></div>
                    <div>
                      <h4 className="text-white font-bold mb-4 font-sans">OTHER LINKS</h4>
                      <div className="space-y-2 text-sm font-sans">
                        <a href="#" className="block text-[#D4C4A8] hover:text-white transition">Companies and Associate Details</a>
                        <a href="#" className="block text-[#D4C4A8] hover:text-white transition">Company Profile</a>
                        <Link to="/client-bank-details" className="block text-[#D4C4A8] hover:text-white transition">Client Bank Details</Link>
                        <Link to="/advisory-on-impersonation" className="block text-[#D4C4A8] hover:text-white transition">Advisory on Impersonation</Link>
                        <Link to="/advisory-for-investors" className="block text-[#D4C4A8] hover:text-white transition">Advisory for Investors</Link>
                        <Link to="/investor-complaints" className="block text-[#D4C4A8] hover:text-white transition">Complaints</Link>
                        <Link to="/risk-disclosure-on-derivatives" className="block text-[#D4C4A8] hover:text-white transition">Risk Disclosure on Derivatives</Link>
                        <a href="/PDF/UPI-Handle.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Transfer of funds via SEBI-validated UPI ID</a>
                      </div>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-1 bg-white mr-4"></div>
                    <div>
                      <h4 className="text-white font-bold mb-4 font-sans">DOWNLOADS</h4>
                      <div className="space-y-2 text-sm font-sans">
                                                                                    <a href="/ARGIL-CRF-Form.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">CRF Form</a>
                                                                                    <a href="/Investor-Charter.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Investor Charter</a>
                                                                                    <a href="/PDF/RMS-Policy_merged.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">RMS Policy</a>
                                                                                    <Link to="/privacy-policy" className="block text-[#D4C4A8] hover:text-white transition">Privacy Policy</Link>
                                                                                    <a href="/PDF/Surveillance-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Surveillance Policy</a>
                                                                                    <a href="/PDF/new-Client-Code-Modification-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Client Code Modification Policy</a>
                                                                                    <a href="/PDF/new-PMLA-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">AML Policy</a>
                                                                                    <a href="/PDF/Policy-regarding-pre-funded-instruments.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Policy Regarding Pre-Funded Instruments</a>
                                                                                    <a href="/PDF/Policy-for-treatment-of-inactive-accounts.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Policy for Treatment of Inactive Accounts</a>
                                                                                  </div>
                    </div>
                  </div>
                </div>
              </div>
      
              <div className="bg-gradient-to-b from-gray-700 to-gray-800 py-6">
                <div className="container mx-auto px-4">
                  <div className="space-y-4 text-xs text-gray-300 font-sans">
                    <div>
                      <p className="font-semibold text-white mb-2">Anand Rathi Global Intermediaries Ltd.</p>
                      <p>CIN : U66120GJ2024PLC148630</p>
                      <p>SEBI Registration No.: INZ000327038 (NSE- 90408)</p>
                    </div>
      
                    <div>
                      <p className="font-semibold text-white mb-2">Disclaimer:</p>
                      <div className="space-y-2 leading-relaxed">
                        <p>
                          Equity: Investment in securities market are subject to market risks, read all the related documents carefully before investing.
                          The securities are quoted as an example and not as a recommendation.
                        </p>
                        <p>
                          Mutual Funds: Mutual fund investments are subject to market risks, read all scheme related documents carefully before investing.
                        </p>
                        <p>
                          Certification/Registration granted by SEBI and certification from NISM is in no way a guarantee of performance of the intermediary or provides any assurance of returns to investors.
                        </p>
                      </div>
                    </div>
      
                    <div>
                      <p className="font-semibold text-white mb-3">Attention Investors:</p>
                      <ul className="space-y-1 leading-relaxed">
                        <li>• For all communication related to vulnerability reporting, security alerts, or any other suspicious activity related to cyber security, contact argil@rathi.com</li>
                        <li>• For any complaints email at <a href="mailto:argilgrievance@rathi.com" className="text-yellow-400 hover:text-yellow-300">argilgrievance@rathi.com</a></li>
                        <li>• Filing of complaints on <a className="text-yellow-400 hover:text-yellow-300" href="https://scores.sebi.gov.in/" traget="_blank">SCORES portal</a> – Easy & quick a. Register on SCORES portal b. Mandatory details for filing complaints on SCORES: I. Name, PAN, Address, Mobile Number, Email ID c. Benefits: I. Effective communication ii. Speedy redressal of the grievances.</li>
                        <li>• Stock Brokers can accept securities as margin from clients only by way of pledge in the depository system w.e.f. September 1, 2020. </li>
                        <li>• Update your mobile number & email Id with your stock broker / depository participant and receive OTP directly from depository</li>
                        <li>• Pay 20% upfront margin of the transaction value to trade in cash market segment</li>
                        <li>• Check your Securities /MF/ Bonds in the consolidated account statement issued by NSDL/CDSL every month</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
    </div>
  );
}